import React from 'react';

import { AuthDto } from '@/store/services/MidleNestApi.service';
import { connect } from 'react-redux';
import { selectAuth } from '@/store/features/auth.slice';
import { RootState } from '@/store';
import LoginComponent from '@/views/auth/login/Login.component';

// import { useModal } from '@/hooks/useModal';

interface Props {
  authData: AuthDto;
}

function LoginView({ authData }: Props) {
  return (
    <div className='flex flex-col mx-auto w-96 text-sm pb-8'>
      <LoginComponent />
    </div>
  );
}

export default connect(
  (state: RootState): Props => ({
    authData: selectAuth(state),
  }),
)(LoginView);
